<template>
  <v-card>
    <v-card-text>
      <v-container fluid>
        <v-layout row wrap>
          <v-text-field
            :label="`配送パターン（枝番‐${shipment.doNo}‐${shipment.branchCode})`"
            disabled
            v-model="shipment.deliveryPatternName"
          ></v-text-field>
        </v-layout>
      </v-container>
      <v-data-table
        :headers="headers"
        :items="shipment.routes"
        :rows-per-page-items="[10]"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td>{{ shipment.forecastDeliveryDate }}</td>
          <td>{{ props.item.departurePortName || props.item.departureWarehouseName }}</td>
          <td>{{ props.item.destinationPortName || props.item.destinationWarehouseName }}</td>
          <td>{{ containerNo() }}</td>
          <td>{{ containerType() }}</td>
          <td>{{ props.item.freightCost }}</td>
          <td>{{ props.item.devanCharge }}</td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['shipment'],
  data() {
    return {
      headers: [
        { text: '配送日', value: 'deliveryDate', sortable: false },
        { text: '発地', value: 'place', sortable: false },
        { text: '着地', value: 'departureWarehouseName', sortable: false },
        { text: 'コンテナNO', value: 'containerNo', sortable: false },
        { text: 'タイプ', value: 'truckTypeId', sortable: false },
        { text: '運送費', value: 'freightCost', sortable: false }, // costs
        { text: 'デバン料', value: 'devanCharge', sortable: false }
      ]
    }
  },
  methods: {
    containerNo() {
      return (
        this.shipment &&
        this.shipment.packages &&
        this.shipment.packages.length > 0 &&
        this.shipment.packages[0].containerNo
      )
    },
    containerType() {
      return (
        this.shipment &&
        this.shipment.packages &&
        this.shipment.packages.length > 0 &&
        this.shipment.packages[0].containerTypeCode
      )
    }
  }
}
</script>